import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_HomeHeader.scss';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { getNoteTemplateId } from '../../../../_utils/get-note-template-id.js';
import { Button, LL_H_C, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Spotlight } from '../../../../modules/ModuleFE_Spotlight/index.js';
import { Component_TimeSinceTriageV2 } from '../v2/time-since-triage/Component_TimeSinceTriageV2.js';
import { Component_RefreshEncounter } from '../../welcome/Component_RefreshEncounter/Component_RefreshEncounter.js';
import { Component_UtilitiesMenu } from '../Component_UtilitiesMenu/Component_UtilitiesMenu.js';
import { Component_HomeTitle } from '../home-title/Component_HomeTitle.js';
const Render_SeePhysicianNotes = () => {
    if (!ModuleFE_EMInterface.isPostDisposition())
        return;
    return _jsx(Button, { className: 'see-notes-button', onClick: async (e) => {
            stopPropagation(e);
            const noteTemplateId = getNoteTemplateId();
            if (!noteTemplateId)
                return;
            const key = ModuleFE_EMInterface.getSmartNoteStorageKey(noteTemplateId);
            let note = key.get();
            if (!note) { //No note in the key is possible if cache was cleared or this is not the machine that we got to dispo with
                //Get data from EM and put it in the key
                const response = await ModuleFE_EMInterface.vv1.smartNote.get({ noteTemplateId: noteTemplateId }).executeSync();
                key.set(response.note);
                note = response.note;
            }
            if (note) //Only open the notes if we actually have a note here
                ModuleFE_Spotlight.openPhysicianNotes({ note });
        }, variant: 'primary', children: "See Physician\u2019s Notes" });
};
export const Component_HomeHeader = () => {
    return _jsxs(LL_H_C, { className: 'home__header', children: [_jsx(Component_HomeTitle, {}), _jsxs(LL_H_C, { className: 'home__header-tail', children: [Render_SeePhysicianNotes(), _jsx(Component_TimeSinceTriageV2, {}), _jsx(Component_RefreshEncounter, {}), _jsx(Component_UtilitiesMenu, {})] })] });
};
//# sourceMappingURL=Component_HomeHeader.js.map